import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

const colHead = "mb-6 text-[11px] font-semibold uppercase tracking-[0.3em] text-white/40";
const colLink =
  "group flex items-center gap-2 py-2 text-sm text-white/70 transition-colors duration-200 hover:text-brand";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-ink text-white">
    <div className="mx-auto grid w-full max-w-[1400px] gap-14 px-6 py-16 sm:px-10 lg:grid-cols-12 lg:px-16 lg:py-24">
      <div className="lg:col-span-5">
        <div className="flex items-center gap-4">
          <img src="/assets/logo-mark.png" alt="Devkii Electricals logo" className="h-12 w-auto rounded-lg" />
          <div>
            <p className="font-heading text-2xl font-bold tracking-tight">Devkii Electricals</p>
            <p className="mt-1 text-[10px] font-medium uppercase tracking-[0.3em] text-brand">
              Known for Innovations
            </p>
          </div>
        </div>
        <div className="mt-8 space-y-5">
          <div data-testid="footer-address-office">
            <p className="text-[10px] font-semibold uppercase tracking-[0.25em] text-brand">Registered Office</p>
            <p className="mt-2 max-w-sm text-sm leading-relaxed text-white/50">
              Unit No. B/26-F, Malad Industrial Estate, Kanchapada, Ramchandra
              Extension Road, Malad West, Mumbai 400064, Maharashtra, India
            </p>
          </div>
        </div>
        <div className="mt-6 space-y-1.5">
          <a href="mailto:info@devkiielectricals.in" data-testid="footer-email" className="block text-sm text-white/60 transition-colors duration-200 hover:text-brand">
            info@devkiielectricals.in
          </a>
          <a href="tel:+917718927246" data-testid="footer-phone" className="block text-sm text-white/60 transition-colors duration-200 hover:text-brand">
            +91 7718927246
          </a>
        </div>
      </div>

      <div className="lg:col-span-2">
        <p className={colHead}>Company</p>
        <Link to="/about" data-testid="footer-about" className={colLink}>
          About Us <ArrowUpRight size={14} className="opacity-0 transition-opacity group-hover:opacity-100" />
        </Link>
        <Link to="/clientele" data-testid="footer-clientele" className={colLink}>
          Clientele <ArrowUpRight size={14} className="opacity-0 transition-opacity group-hover:opacity-100" />
        </Link>
      </div>

      <div className="lg:col-span-2">
        <p className={colHead}>Explore</p>
        <Link to="/catalog" data-testid="footer-catalog" className={colLink}>
          Catalog <ArrowUpRight size={14} className="opacity-0 transition-opacity group-hover:opacity-100" />
        </Link>
        <Link to="/contact" data-testid="footer-contact" className={colLink}>
          Contact Us <ArrowUpRight size={14} className="opacity-0 transition-opacity group-hover:opacity-100" />
        </Link>
        <Link to="/" data-testid="footer-home" className={colLink}>
          Home <ArrowUpRight size={14} className="opacity-0 transition-opacity group-hover:opacity-100" />
        </Link>
      </div>

      <div className="lg:col-span-3">
        <p className={colHead}>Work with us</p>
        <p className="max-w-xs text-sm leading-relaxed text-white/50">
          Looking for a manufacturing partner for electromechanical switches?
        </p>
        <Link
          to="/contact"
          data-testid="footer-cta"
          className="mt-6 inline-flex items-center gap-3 border border-white/25 px-7 py-3.5 text-[12px] font-semibold uppercase tracking-[0.22em] transition-colors duration-300 hover:border-brand hover:bg-brand"
        >
          Start a conversation
          <ArrowUpRight size={15} />
        </Link>
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="mx-auto flex w-full max-w-[1400px] flex-col gap-2 px-6 py-6 text-xs text-white/40 sm:flex-row sm:items-center sm:justify-between sm:px-10 lg:px-16">
        <span data-testid="footer-copyright">© 2026 Devkii Electricals. All rights reserved.</span>
        <span>Mumbai · Maharashtra · India</span>
      </div>
    </div>
  </footer>
);
